import React, { useState } from 'react'
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";



const Contact = () => {

    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(
                "service_85vncqh",
                "template_sh7wgvk",
                "#myForm",
                "dphUMCkFYP0BZruxu"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };

    return (
        <>
            <main>
                {/*======  Start Page Hero Section  ======*/}
                <section className="page-hero bg_cover p-r z-1" style={{ backgroundImage: 'url("assets/img/TDR.jpg")' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                {/*=== Page Content ===*/}
                                <div className="page-content text-center">
                                    <h1>Contact Us</h1>
                                    <ul>
                                        <li><Link to="/">Home</Link></li>
                                        <li>Contact Us</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*======  Start Contact Info Section  ======*/}
                <section className="renvia-contact-info-sec pt-105">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/*=== Section Title ===*/}
                                <div className="section-title text-center mb-50 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1000} style={{ marginTop: "-80px" }}>
                                    <h2>Our Contact Information</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-xl-4 col-md-6 col-sm-12">
                                {/*=== Renvia Info Box ===*/}
                                <div className="renvia-info-left-box mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1000}>
                                    <div className="icon">
                                        <i className="far fa-map-marker-alt" />
                                    </div>
                                    <div className="content">
                                        <h5>Our Address</h5>
                                        <p><a href='https://share.google/Xk1dCdHZxcdtaAQi4' target="_blank" rel="noopener noreferrer">B-17 Pooja Hospital Complex, Panna naka, Satna 485001</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-md-6 col-sm-12">
                                {/*=== Renvia Info Box ===*/}
                                <div className="renvia-info-left-box mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1200}>
                                    <div className="icon">
                                        <i className="far fa-phone-alt" />
                                    </div>
                                    <div className="content">
                                        <h5>Contact Number</h5>
                                        <p><span><a href="tel:+91 8823000048">+91 8823000048 </a></span></p>
                                        <p><span><a href="tel:+91 7580843224"> +91 7580843224</a></span></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-md-6 col-sm-12">
                                {/*=== Renvia Info Box ===*/}
                                <div className="renvia-info-left-box mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1400}>
                                    <div className="icon">
                                        <i className="far fa-envelope" />
                                    </div>
                                    <div className="content">
                                        <h5>Email: </h5>

                                        <p><span><a href="mailto:earthbondproperty@gmail.com">earthbondproperty@gmail.com</a></span></p>

                                        {/* <h5>Opening Hour</h5>
                                        <p>Mon - Sat: 9:00 - 18:00</p>
                                        <p>Sunday: Closed</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>{/*======  End Contact Info Section  ======*/}
                {/*======  Start Contact Section  ======*/}
                <section className="renvia-contact_three pt-80 pb-120">
                    <div className="container">
                        {/*=== Contact Wrapper ===*/}
                        <div className="contact-wrapper aos-init aos-animate" data-aos="fade-up" data-aos-duration={1000} style={{ marginTop: "-100px" }}>
                            <h3>Get In Touch</h3>
                            <form id="contact-form" className="contact-form" action="contact.php" method="POST">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label><i className="far fa-user" /></label>
                                            <input type="text" className="form_control" placeholder="Your Name" name="name" required />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label><i className="far fa-envelope" /></label>
                                            <input type="email" className="form_control" placeholder="Email Address" name="email" required />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label><i className="far fa-phone" /></label>
                                            <input type="text" className="form_control" placeholder="Phone Number" name="phone" required />
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label><i className="far fa-pen" /></label>
                                            <textarea className="form_control" placeholder="Message" name="message" rows={5} cols={8} defaultValue={""} />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group text-center">
                                            <Link to=''>
                                                <button className="theme-btn style-one">Send Message Us <i className="far fa-arrow-right" /></button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>{/*======  End Contact Section  ======*/}
                <section className="contact-map-sec aos-init aos-animate" data-aos="fade-up" data-aos-duration={1000} style={{ marginTop: "-150px" }}>
                    {/*=== Map Box ===*/}
                    <div className="map-box mt-5 mt-xl-0 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1200}>
                        <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1600&height=400&hl=en&q=Earth Bond Property&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">embed google maps in website</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>
                    </div>
                </section>
            </main>

        </>
    )
}

export default Contact